export var companyinfoTestData = {
    "id": 1,
    "prefix_name": "บริษัท",
    "company_name": "ค้าขายมั่งมี",
    "suffix_name": "จำกัด",
    "tax_id": "0565562000208",
    "branch_name": "สาขา",
    "branch_code": "00001",
    "phone_number": "082-342-9555",
    "website": "www.junebakermart.com",
    "email": "purchasing.junebakermart@gmail.com",
    "line": "@siamcoffeetrade",
    "created_at": "2024-10-28T02:02:33.000Z",
    "updated_at": "2024-10-28T02:02:33.000Z"
};
